import { gql } from '@apollo/client';

export default gql`
  mutation addPayoutAndBalance(
    $bookingReference: String!
    $amount: Float!
    $currency: Currency!
    $method: PaymentMethodEnum!
    $externalReference: String
    $reference: String!
    $isPrrRefund: Boolean
  ) {
    addPayoutAndBalance(
      bookingReference: $bookingReference
      amount: $amount
      currency: $currency
      method: $method
      externalReference: $externalReference
      reference: $reference
      isPrrRefund: $isPrrRefund
    ) {
      bookingReference
      payout {
        refId
      }
      balance {
        refId
      }
    }
  }
`;
